import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Paper,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  styled,
  tableCellClasses,
} from "@mui/material";
import { useRef } from "react";
import React, { useEffect, useState } from "react";
import { Box, FormControlLabel, Grid, Typography } from "@mui/material";
import { AppFilter } from "../../models/app/AppModels";
import PageLoader from "../app/PageLoader";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { DmsLocations } from "../../models/auth/Auth";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchIcon from "@mui/icons-material/Search";
import {
  CheckoutDetail,
  DraftOrderAddress,
  DraftOrderRequest,
  PartsCheckoutDetail,
  PartsCheckoutInitialValues,
  PartsCheckoutValidationSchema,
} from "../../models/features/Gravity/CheckoutDetail";
import {
  useAddTransactionHistoryMutation,
  useGetTransactionTokenMutation,
} from "../../redux/reducer/features/Customer/CustomerSlice";
import { ErrorMessage, Form, Formik, FormikProps } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import {
  addToCart,
  removeCart,
  setOpenCheckout,
  useCalculateTaxMutation,
  useCreateShoppingPortalOrderMutation,
  useAddPayPalTransactionHistoryMutation,
  useGetPayPalClientIdMutation,
  useGetDmsPartsMutation,
  useAddToCartPartMutation,
} from "../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import {
  Address,
  TargetOrderRequest,
  TaxLines,
} from "../../models/features/ShoppingPortal/ShoppingPortalOrderHookRequest";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {
  DmsCategory,
  DmsManufacturer,
} from "../../models/features/ShoppingPortal/DmsManufacturer";
import {
  DmsPart,
  DmsPartRequestDto,
} from "../../models/features/ShoppingPortal/DmsPart";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { getFullName, getPartPrice } from "../../services/utilities/utility";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import { PortalSettingRule } from "../../models/features/ShopifySetting/Portal Setting Rules/PortalSettingRules";
import { PartsList } from "./Common/PartsList";
import { PartsListFilter } from "./Common/PartsListFilter";
import { CheckOutDialog } from "./Dialog/CheckOutDialog";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

declare const emergepay: any;
export const Parts: React.FunctionComponent = () => {
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 20,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [tab, setTab] = React.useState<"Parts">("Parts");
  const [isLoadingParts, setIsLoadingParts] = React.useState(false);
  const dispatch = useDispatch();
  const cart = useSelector(
    (state: AppState) => state.shoppingPortalReducer.cart,
  );
  const dmsLocations = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.dmsLocations,
  );
  const hideMfgs = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting?.hideMfgs,
  );
  const rules = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting.settingRules,
  );
  const shippingCharges = useSelector((state: AppState) =>
    state.shoppingPortalReducer.portalSettings?.setting.shippingCharge.toString(),
  );
  const { customerData } = useSelector((state: AppState) => state.authReducer);
  const setupId = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting.dmsSetupId,
  );

  const dmsDealerId = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.dmsDealerId,
  );
  const pricing = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.pricing,
  );

  const [getDmsPartsMutation, getDmsPartsMutationResult] =
    useGetDmsPartsMutation();

  const [addToCartPartMutation, addToCartPartResult] =
    useAddToCartPartMutation();
  const [
    addPayPalTransactionHistoryMutation,
    addPayPalTransactionHistoryMutationResult,
  ] = useAddPayPalTransactionHistoryMutation();
  const [dmsParts, setDmsParts] = useState<DmsPart[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedManufacturers, setSelectedManufacturers] = useState<string[]>(
    [],
  );
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedLocations, setSelectedLocations] = React.useState<
    DmsLocations[]
  >([]);
  const [partsCheckoutDetail, setPartsCheckoutDetail] = React.useState<any>(
    PartsCheckoutInitialValues,
  );
  const [selectedPart, setSelectedPart] = React.useState<any>(null);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const formRef = useRef<FormikProps<PartsCheckoutDetail>>(null);
  const isMounted1 = useRef(false);
  const isMounted2 = useRef(false);

  useEffect(() => {
    if (customerData && customerData.email) {
      setPartsCheckoutDetail({
        ...partsCheckoutDetail,
        billingName: customerData.displayName,
        email: customerData.email,
        phone: customerData.phone,
      });
    }
  }, [customerData]);

  const fetchDmsPartsData = () => {
    setIsLoadingParts(true);
    var partNotIncludedRules = rules?.filter((rule) => rule.hideParts) ?? [];
    let notIncludedParts = partNotIncludedRules.flatMap(
      (rule) => rule.partNumbers || [],
    );
    var data: DmsPartRequestDto = {
      dealerIds:
        selectedLocations.length > 0
          ? selectedLocations.map((loc) => loc.dealerId.toString())
          : (dmsLocations
              ?.filter((n) => n.storeLocationId > 0)
              .map((n: any) => n.dealerId.toString()) ?? []),
      pageSize: paging.pageSize,
      pageNumber: paging.pageIndex,
      stockingOnly: true,
      searchPartNumber: [],
      searchPartDescription: "",
      search: search,
      searchManufacturerId: "",
      searchManufacturerCode: selectedManufacturers.map((mfg) =>
        mfg.toString(),
      ),
      searchManufacturerCodeNotIn: hideMfgs ?? [],
      inventoryPartIdNotIn: notIncludedParts,
      categoryIds: selectedCategories.map((cat) => cat.toString()),
    };

    getDmsPartsMutation({ data: data })
      .then((response: any) => {
        if (response?.data && response?.data?.entityList !== null) {
          var partsResponse = response?.data?.entityList?.map((item: any) => ({
            ...item,
            price: getPartPrice(item, pricing),
          }));
          if (paging.pageIndex > 0) {
            setDmsParts([...dmsParts, ...partsResponse]);
          } else {
            setDmsParts(partsResponse);
            setTotalRecords(response.data.totalRecords);
          }
        }
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoadingParts(false);
      });
  };
  const fetchMoreData = () => {
    setPaging({ ...paging, pageIndex: paging.pageIndex + 1 });
  };

  React.useEffect(() => {
    if (dmsLocations !== undefined && dmsDealerId !== undefined) {
      fetchDmsPartsData();
    }
  }, [dmsDealerId]);

  React.useEffect(() => {
    if (
      dmsLocations !== undefined &&
      dmsDealerId !== undefined &&
      isMounted1.current
    ) {
      fetchDmsPartsData();
    } else {
      isMounted1.current = true;
    }
  }, [paging]);

  React.useEffect(() => {
    if (isMounted2.current) {
      if (dmsLocations !== undefined && dmsDealerId !== undefined) {
        setPaging({ ...paging, pageIndex: 0 });
        setDmsParts([]);
      }
    } else {
      isMounted2.current = true;
    }
  }, [selectedLocations, selectedManufacturers, selectedCategories]);

  const handleAddToCart = (part: DmsPart) => {
    addToCartPartMutation({ dmsSetupId: setupId ?? "", part: part }).then(
      (res) => {
        console.log(res, "res");
        window.parent.postMessage(res, "https://utopiaweb.net");
      },
    );
  };

  return (
    <>
      <Container maxWidth="xl">
        <PageLoader isLoading={!dmsLocations || isLoading}></PageLoader>
        <Grid container mt={5}>
          <Grid item md={12}>
            <Box minHeight={100} bgcolor={"#f3f3f3"}>
              <Grid p={5}>
                <Typography variant="h4" fontWeight="bold">
                  {tab}
                </Typography>
              </Grid>
            </Box>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={8} mb={5}>
              <Grid item xs={12} md={3}>
                <PartsListFilter
                  isLoading={getDmsPartsMutationResult.isLoading}
                  setPaging={setPaging}
                  selectedManufacturers={selectedManufacturers}
                  setSelectedManufacturers={setSelectedManufacturers}
                  selectedLocations={selectedLocations}
                  setSelectedLocations={setSelectedLocations}
                  setSearch={setSearch}
                  search={search}
                  selectedCategories={selectedCategories}
                  setSelectedCategories={setSelectedCategories}
                ></PartsListFilter>
              </Grid>
              <Grid item xs={12} md={9}>
                <PartsList
                  fetchMoreData={fetchMoreData}
                  handleAddToCart={(item: any) => {
                    setSelectedPart(item);
                    dispatch(
                      addToCart({
                        cartItem: {
                          inventoryPartId: item.inventoryPartId,
                          partNumber: item.partNumber,
                          description: item.description,
                          price: item.price,
                          mfrCode: item.mfrCode,
                          quantity: 1,
                          locationCount: item.locationCount,
                        },
                      }),
                    );
                  }}
                  isLoadingParts={isLoadingParts}
                  parts={dmsParts}
                  totalRecords={totalRecords}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <CheckOutDialog></CheckOutDialog>
    </>
  );
};

export const searchOptions = {
  types: ["address"],
};
